<template>
  <div class="wrapper_filters">
    <div
      v-for="item in traffic.periods"
      :key="item.title"
      class="period"
      :class="{ selected: getSelected(item.value, traffic.activePeriod) }"
      @click="onChange(item)"
    >
      {{ $t(`main.traffic.${item.value}`) }}
    </div>
    <div v-if="isMobile" class="action-buttons">
      <div class="action-btn action-btn_add" @click="openAddDomain">
        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="3.5" stroke-linecap="round" stroke-linejoin="round">
          <line x1="12" y1="5" x2="12" y2="19"/>
          <line x1="5" y1="12" x2="19" y2="12"/>
        </svg>
      </div>
      <div class="action-btn" @click="share">
        <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 12v8a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-8"/>
          <polyline points="16 6 12 2 8 6"/>
          <line x1="12" y1="2" x2="12" y2="15"/>
        </svg>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations, mapGetters, mapState } from 'vuex'
import isMobileFn from '@/helpers/base/isMobile'

export default {
  computed: {
    ...mapState('traffic', {
      traffic: state => state,
    }),
    isMobile() {
      return isMobileFn()
    },
  },
  methods: {
    ...mapActions('traffic', ['changePeriod']),
    ...mapMutations('traffic', ['updateActivePeriod']),
    getSelected: (value, activePeriod) => {
      if (value === '1year' && !activePeriod) return true
      if (value === activePeriod) return true
    },
    onChange(item) {
      return this.changePeriod(item.value)
    },
    changePeriod(item) {
      this.updateActivePeriod(item)
    },
    share() {
      if (navigator.share) {
        navigator.share({
          url: window.location.href,
        })
      }
    },
    openAddDomain() {
      this.$store.dispatch('addDomainModal/show')
    },
  },
}
</script>

<style scoped>
.wrapper_filters {
  display: flex;
  margin: 5px 0;
}
.period {
  background: var(--bg-surface-2);
  border-radius: 8px;
  height: 37px;
  width: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 500;
  font-size: 14px;
  line-height: 19px;
  text-align: center;
  color: var(--text-secondary2);
  cursor: pointer;
}

.period + .period {
  margin-left: 7px;
}

.action-buttons {
  display: flex;
  margin-left: 20px;
}

.action-btn {
  background: var(--bg-surface-2);
  border-radius: 8px;
  height: 37px;
  width: 37px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: var(--text-secondary2);
}

.action-btn + .action-btn {
  margin-left: 7px;
}

.action-btn:active {
  background: var(--bg-surface-3);
}

/* добавить сайт — главное действие на мобильном, выделяем как выбранный период */
.action-btn_add {
  background: var(--main-color);
  color: #ffffff;
  box-shadow: 0px 4px 14px rgba(38, 132, 254, 0.35);
}

.action-btn_add:active {
  background: #1a6fe0;
}

.period.selected {
  background: var(--main-color);
  box-shadow: var(--shadow-card);
  color: #ffffff;
}
</style>
